<template>
  <div
    v-if="customWidget"
    class="widget white_box"
  >
    <div class="widget_header">
      <h3 class="tw-text-neutral-900 tw-text-2xl">
        {{ customWidget.heading }}
      </h3>
      <div
        v-if="editing"
        class="edit_buttons"
      >
        <DefaultButton
          size="small"
          variant="danger"
          @click="$parent.remove()"
        >
          Delete
        </DefaultButton>
      </div>
    </div>
    <div
      class="content"
      v-html="customWidget.code"
    />
  </div>
</template>

<script>
import _ from 'lodash';
import {mapState} from 'vuex';
import DefaultButton from "@/components/global-themed/buttons/DefaultButton.vue";

export default {
  components: {DefaultButton},
  props: {
    widget: {
      type: Object,
      required: true,
    },
    editing: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    ...mapState('dashboard', ['customWidgets']),
    customWidget() {
      return _.find(this.customWidgets, {id: this.widget.custom_widget_id});
    },
  }
}
</script>

<style scoped>
.content {
  height: 326px;
  overflow: hidden;
}
</style>
